import i18n from 'config/i18n/i18n';
import {loyaltyApolloClientWithToken, productApolloClient} from 'utils';

import {ECODE_ACTIVATION, GET_RM3_PROMOTION} from './queries';
import {PromoAdvice} from '../../types';

export const redeemEcode = async (code: string, idToken: string) => {
  try {
    const client = loyaltyApolloClientWithToken(idToken);
    const {data, errors} = await client.mutate({
      mutation: ECODE_ACTIVATION,
      variables: {
        code
      },
      errorPolicy: 'all'
    });
    return {data, errors};
  } catch (error: any) {
    return null;
  }
};

export const getRmPromotions = async (
  skus: string[],
  storeCodes: string[]
): Promise<Record<string, {promoAdvice: PromoAdvice[]}> | undefined> => {
  try {
    const client = productApolloClient();
    const result = await client.mutate({
      mutation: GET_RM3_PROMOTION,
      variables: {
        lang: i18n.language,
        conditionFilter: 'ALL',
        storeCodes,
        makroIds: skus
      },
      errorPolicy: 'all'
    });

    if (result?.data?.getRM3Promotions) {
      const response = result.data.getRM3Promotions;
      return response.reduce((acc: Record<string, {promoAdvice: PromoAdvice[]}>, promo: PromoAdvice) => {
        const {itemId} = promo;

        // Initialize the key if it doesn't exist
        if (!acc[itemId]) {
          acc[itemId] = {promoAdvice: []};
        }

        // Add the promoId to the promoAdmin array
        acc[itemId].promoAdvice.push(promo);

        return acc;
      }, {});
    }
  } catch (e) {
    return {};
  }
};
